<template>
  <div id="start">
    <div>
      <img src="./start/assets/Memory.jpg" class="start-img" />
      <div class="overlay text-white">
        {{text}}
      </div>
    </div>
    <futureIT :language="language"></futureIT>
  </div>
</template>

<script>
import futureIT from './start/FutureIT'
const SECTIONID = 13

export default {
  name: 'start',
  props: ['language'],
  components: {
    futureIT
  },
  data () {
    return {
      text: ''
    }
  },
  watch: {
    language: function () {
      this.handleLanguage()
    }
  },
  created: function () {
    this.handleLanguage()
  },
  methods: {
    handleLanguage: function () {
      this.text = this.$root.getText(SECTIONID)
    }
  }
}
</script>

<style scoped>

#start {
  width: 100%;
  height: auto;
}

.start-img {
  width: 100%;
  height: 90vh;
  object-fit: cover;
  object-position: center;
}

.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 20px;
  text-shadow: 2px 2px 2px black, 0 0 1em black, 0 0 0.1em black;
}

</style>



// WEBPACK FOOTER //
// src/components/Start.vue